import { render, staticRenderFns } from "./schoolInfo.vue?vue&type=template&id=45fe11c6"
import script from "./schoolInfo.vue?vue&type=script&lang=js"
export * from "./schoolInfo.vue?vue&type=script&lang=js"
import style0 from "./schoolInfo.vue?vue&type=style&index=0&id=45fe11c6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports